import { Component, OnInit, OnDestroy } from '@angular/core';
import { SystemSelectService } from '../../system-select/system-select.service';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'configuration',
  templateUrl: './configuration.component.html',
  // styleUrls: ['./configuration.component.scss']
})
export class ConfigurationComponent implements OnInit, OnDestroy {

  constructor(public router: Router, private systemSelectService: SystemSelectService, ) { }

  system: any;


  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  tabs = [
    {
      title: "System Layout",
      route: "SystemLayout"
    },
    {
      title: "Build Tools",
      route: "BuildTools",
    },
    // {
    //   title: "Furnished Equipment Tools",
    //   route: "FurnishedEquipmentTools",
    // },
    {
      title: "Legacy Tools",
      route: "LegacyTools",
    },
  ]

  ngOnInit() {
    this.systemSelectService.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(system => this.system = system);
    this.systemSelectService.get();

    this.router.events
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((val) => {
        this.setSelectedTab();
      });

    this.setSelectedTab();
  }

  //handle tab change when changing URL via browser / refreshing the page
  setSelectedTab() {
    var componentUrl = this.router.url.split("/").pop();
    this.tabs.map(function (tab) {
      tab["selected"] = false;
    });

    for (var i = 0; i < this.tabs.length; i++) {
      if (this.tabs[i].route === componentUrl) {
        this.tabs[i]["selected"] = true;
        return;
      }
    }
  }

  selectedId: string = "";


  public handleSelect({ index }): boolean {
    this.router.navigate(["/MESC/CAMTL/MasterToolList/Configuration/" + this.tabs[index].route]);
    return false;
  }
}
